export const galleryImages = [
  {
    url: 'https://customer-assets.emergentagent.com/job_fresh-fast-casual/artifacts/kjczr4z1_Screenshot%202026-04-06%20at%2018.22.51.png',
    title: 'Frytokebab z sosem',
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_fresh-fast-casual/artifacts/640cosiu_Screenshot%202026-04-06%20at%2018.23.00.png',
    title: 'Kebab na Rynku',
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_fresh-fast-casual/artifacts/04uszuwy_Screenshot%202026-04-06%20at%2018.23.09.png',
    title: 'Kurczak Panierowany',
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_fresh-fast-casual/artifacts/mmjw1rkh_Screenshot%202026-04-06%20at%2018.23.17.png',
    title: 'Kebab Fresh Chicken',
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_fresh-fast-casual/artifacts/i89v8d7t_Screenshot%202026-04-06%20at%2018.23.42.png',
    title: 'Zestaw z Kurczakiem',
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_fresh-fast-casual/artifacts/hwf3c50n_image.png',
    title: 'Zestaw z Kubłkiem',
  },
];
